import React, { useState } from 'react';
import styles from './welcome.module.css';

const Welcome = () => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  return (
    <section id="welcome" role="complementary" aria-label="welcome" className={styles.section}>
      <h3>WELCOME to KNOW</h3>
      <p>
        <span style={{ fontWeight: 'bold' }}>KNOW</span> is a tool that allows access to up-to-date
        research on natural agents in cancer care. KNOW systematically searches and presents
        relevant human studies, including clinical trials, from Medline and EMBASE.
      </p>
      <br />
      <p>
        In KNOW, data is searchable by tumor type, natural therapy, conventional treatment, and side
        effects. You can copy references into professional communications, academic projects or
        presentations, education materials, curriculum, and websites. KNOW provides convenient links
        to the publisher for full text review or access.
      </p>
      <br />
      <p>
        Membership to KNOW is subscription-based, providing access for individuals, cancer care
        teams, research groups, academic project groups, hospitals, and public education
        organizations.
      </p>
      <br />
      Key Benefits of KNOW
      <ul>
        <li>
          <b>Answers questions about natural therapies in cancer care</b>
        </li>
        <li>
          <b>
            AI chat-assisted exploration of summaries from curated library of thousands of human
            clinical trials
          </b>
        </li>
        <li>
          <b>Build for deep research and point-of-care use</b>
        </li>
        <li>Evidence at your fingertips grounded in clinical research, not the open web</li>
        <li>Humans double screen, summarize & tag studies</li>
        <li>Supports development of educational resources</li>
        <li>Comprehensive and cost-effective</li>
      </ul>
      <br />
      <div className={styles.videoWrapper}>
        {isVideoPlaying ? (
          <iframe
            src="https://www.youtube.com/embed/yRttFrdc2nA?autoplay=1"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="KNOW Database 101"
            name="KNOW Database 101"
          ></iframe>
        ) : (
          <button
            type="button"
            className={styles.videoFacade}
            onClick={() => setIsVideoPlaying(true)}
            aria-label="Play KNOW Database 101 video"
          >
            <img
              src="https://i.ytimg.com/vi/yRttFrdc2nA/maxresdefault.jpg"
              alt="KNOW Database 101 video thumbnail"
            />
            <span className={styles.videoTitle}>KNOW Database 101</span>
            <span className={styles.playButton} aria-hidden="true"></span>
          </button>
        )}
      </div>
    </section>
  );
};

export default Welcome;
